import script from "./MainLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./MainLayout.vue?vue&type=script&setup=true&lang=js"

import "../styles/mainLayout.css?vue&type=style&index=0&lang=css&external"

const __exports__ = script;

export default __exports__